import { Avatar, Flex, Loader, ScrollAreaAutosize } from "@mantine/core";
import { BoxTitle, Container, LastUpdate } from "./StyledComponents";
import {
  ArrowLeftEndOnRectangleIcon,
  ArrowRightEndOnRectangleIcon,
  MapPinIcon,
} from "@heroicons/react/24/outline";
import styled from "styled-components";
import { theme } from "../../theme";
import { useEffect, useState } from "react";
import { getLiveActivity } from "../../api/dashboardApi";
import dayjs from "dayjs";
import CustomSelect from "../common/Inputs/CustomSelect";
import CustomSearchInput from "../common/Inputs/CustomSearchInput";
import { useFilterContext } from "../../context/DashboardFilterContext";
import { useAuth } from "../../context/AuthContext";

const LiveActivity = ({ flex }: { flex: any }) => {
  const { terminalSelectData } = useAuth();
  const { filters } = useFilterContext();
  const [activities, setActivities] = useState<any>();
  const [isloading, setIsLoading] = useState(false);
  const [otherFilters, setOtherFilters] = useState({
    name: "",
    terminal: "",
    action: "",
    status: "",
  });

  const colors = [
    {
      color: theme.colors.alert.green,
      background: "#ECFDF3",
    },
    {
      color: theme.colors.alert.orange,
      background: "#FFFAEB",
    },
    {
      color: theme.colors.alert.red,
      background: "#FEF3F2",
    },
    {
      color: theme.colors.alert.blue,
      background: "#F0F9FF",
    },
  ];

  const getData = async () => {
    setIsLoading(true);
    try {
      const response: any = await getLiveActivity(filters, otherFilters);
      if (response?.success) {
        setIsLoading(false);
        setActivities(response?.data?.activities);
      } else {
        //toast koyulabilir
      }
    } catch (error) {}
  };

  useEffect(() => {
    getData();
  }, [filters, otherFilters]);

  return (
    <Container $flex={flex}>
      <Flex justify={"space-between"}>
        <BoxTitle>Canlı Aktivite</BoxTitle>
      </Flex>
      <Flex gap={12}>
        <CustomSelect
          data={[
            { value: "0", label: "Çıkış" },
            {
              value: "1",
              label: "Giriş",
            },
          ]}
          onChange={(e: any) =>
            setOtherFilters((prev) => ({
              ...prev,
              action: e,
            }))
          }
          placeholder="Giriş/Çıkış"
          searchable={false}
        />
        <CustomSelect
          data={terminalSelectData}
          onChange={(e: any) =>
            setOtherFilters((prev) => ({
              ...prev,
              terminal: e,
            }))
          }
          placeholder="Terminal"
        />
        <CustomSelect
          data={[
            {
              value: "1",
              label: "Vaktinde",
            },
            {
              value: "2",
              label: "Erken",
            },
            {
              value: "3",
              label: "Geç",
            },
          ]}
          onChange={(e: any) =>
            setOtherFilters((prev) => ({
              ...prev,
              status: e,
            }))
          }
          placeholder="Durum"
          searchable={false}
        />
        <CustomSearchInput
          onChange={(e: any) =>
            setOtherFilters((prev) => ({
              ...prev,
              name: e.target.value,
            }))
          }
          placeholder="İsim"
          searchable={false}
        />
      </Flex>
      {false ? (
        <Flex h={"100%"} justify={"center"} align={"center"}>
          <Loader />
        </Flex>
      ) : (
        <ScrollAreaAutosize h={"76%"}>
          <Flex direction={"column"} gap={12}>
            {activities?.map((activity: any, i: any) => (
              <Flex key={i} h={56} gap={4}>
                <IconWrapper
                  $bg={activity.action === 0 ? "#FEF3F2" : "#ECFDF3"}
                  $color={
                    activity.action === 0
                      ? theme.colors.alert.red
                      : theme.colors.alert.green
                  }
                >
                  {activity.action === 0 ? (
                    <ArrowLeftEndOnRectangleIcon
                      strokeWidth={2}
                      color={theme.colors.alert.red}
                      height={20}
                    />
                  ) : (
                    <ArrowRightEndOnRectangleIcon
                      strokeWidth={2}
                      color={theme.colors.alert.green}
                      height={20}
                    />
                  )}
                  <div className="text">
                    {activity.action === 0 ? "Çıkış" : "Giriş"}
                  </div>
                </IconWrapper>

                <InfoCard>
                  <Flex flex={4} gap={8}>
                    <Avatar size={28}>{activity?.employeeName[0]}</Avatar>
                    <Flex direction={"column"} gap={8}>
                      <div className="name">{activity?.employeeName}</div>
                      <Flex align={"center"} gap={2}>
                        <MapPinIcon
                          color={theme.colors.greyscale.gray80}
                          height={14}
                        />
                        <div className="location">{activity?.terminalName}</div>
                      </Flex>
                    </Flex>
                  </Flex>
                  <Flex justify={"space-between"} gap={8} flex={1}>
                    <Flex justify={'end'} flex={1}>
                      <Badge
                        $bg={colors[activity?.status?.status]?.background}
                        $color={colors[activity?.status?.status]?.color}
                      >
                        {activity?.status?.message}
                      </Badge>
                    </Flex>
                    <Flex w={"45px"}>
                      {dayjs(activity.date).format("HH:mm")}
                    </Flex>
                  </Flex>
                </InfoCard>
              </Flex>
            ))}
          </Flex>
        </ScrollAreaAutosize>
      )}
    </Container>
  );
};

export default LiveActivity;

const IconWrapper = styled.div<{ $color: string; $bg: string }>`
  display: flex;
  gap: 4px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 6px 12px;
  color: ${({ $color }) => $color};
  background: ${({ $bg }) => $bg};
  border-radius: 6px;
`;

const InfoCard = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  border: 1px solid ${theme.colors.greyscale.gray20};
  border-radius: 6px;
  .name {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${theme.colors.greyscale.black};
  }
  .location {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: ${theme.colors.greyscale.gray80};
  }
`;

const Badge = styled.div<{ $bg: string; $color: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: max-content;
  height: 28px;
  padding: 6px 8px;
  gap: 4px;
  border-radius: 30px;
  color: ${({ $color }) => $color};
  background-color: ${({ $bg }) => $bg};
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
`;
